// extracted by mini-css-extract-plugin
module.exports = {"header":"ProGeneralDetails_header__p9yjp","activePatients":"ProGeneralDetails_activePatients__LXvGh","footer":"ProGeneralDetails_footer__ohEiA"};